import {
    PageTitleText 
 } from '../../../../widget/styledComponents/headings.style';

import {
    AddNewEstateContainer,AddNewEstateContainerTitleSection
 } from './addEstate.style';

import {
    AppInputField,InputFieldTitleText,AppInputFieldBtn,AppInputFieldBtnCancel 
} from './../../../../widget/styledComponents/input_field.style'
import React ,{ useRef,useState } from "react";
import { gql, useMutation } from '@apollo/client';

import Cookies from 'js-cookie';
import { toaster } from 'evergreen-ui';
import DropdownWidget from '../../../../widget/dropdown';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { localGovernmentAreas, nigerianStates } from '../../../../widget/state&lga';

export const ADD_ESTATE = gql`
mutation Facility_create($name: String!, $type: AssetType!, $address: String!, $country: String!, $state: String!, $city: String!, $asBuiltDrawing: String) {
  facility_create(name: $name, type: $type, address: $address, country: $country, state: $state, city: $city, asBuiltDrawing: $asBuiltDrawing) {
    code
    success
    error
    data {
      _id
      code
      type
      name
      facilityManager
      totalProperties
      occupiedProperties
      availableProperties
      address
      country
      state
      city
      createdAt
      asBuiltDrawing
      id
    }
  }
}
`;



function AddAssetsPageWidget() {
const accesTokenValue = Cookies.get('userAccessToken');
const history = useHistory()


const [addAssets, { loading }] = useMutation(ADD_ESTATE);
const [dataObject, setDataObject] = useState({
  state:"",
  asBuiltDrawing:""
});

const handleSubmit=(e)=>{
    e.preventDefault()


    console.log("e==",dataObject);
   
    addAssets({
        variables: dataObject,
        context: {
          headers: {
            Authorization: `Bearer ${accesTokenValue}`,
          },
        },
      })
      .then((response) => {
        toaster.success("Estate added successfully.")
        toaster.success("Please select assets to manage to")
        history.push('/listEstates')
        window.location.reload()
      })
      .catch((error) => {
        toaster.danger(error.message)
      });
  }


const nameRef = useRef(null);


const handleSelectionChange = (name='',option) => {
    console.log("name-===",name)
    console.log("value==",option)

// estate
// single_or_group_of_properties
    if(name==='state'){
      setTimeoutToRefresh()
    }

    if(option==="Full Estate" || option==="Stand Alone Property"){
        setDataObject({
            ...dataObject,
            [name]: option ==='estate'?"estate":"single_or_group_of_properties"
        });
    }else{
        setDataObject({
        ...dataObject,
        [name]: option
        });
    }
};

  
const handleInputChange = (event) => {
  const { name, value } = event.target;

    setDataObject({
      ...dataObject,
      [name]: value
    });
  
};

const [showlga,setShowlga] = useState(false)
const setTimeoutToRefresh=()=>{
  setShowlga(false)
  setTimeout(()=>{
    setShowlga(true)
  },1000);
}

  return (
    <div className=''>
       <br/><br/>
        <div className='row'>
            <div className='col s12 m12 l3'></div>
            <div className='col s12 m12 l6'>
                <form onSubmit={handleSubmit}>
                <AddNewEstateContainer>
                    <AddNewEstateContainerTitleSection>
                        <PageTitleText className='pl-16 pt-25 p-16'  style={{
                                color:"#4F46E5 !important",
                                padding:"16px !important"
                            }}>
                                Add Assets 
                        </PageTitleText>
                    </AddNewEstateContainerTitleSection>


                    <div className='p-16'>
                        <div className='row'>
                            <div className='col s12 m12 l12'>
                                <InputFieldTitleText>
                                    Asset Name
                                </InputFieldTitleText>
                                <AppInputField
                                    type="text" 
                                    name='name'
                                    onChange={handleInputChange}
                                required/> 
                            </div>
                            <div className='col s12 '>
                                  <InputFieldTitleText>
                                  Assets Type
                                  </InputFieldTitleText>
                                  <div className='col s12'>
                                    <DropdownWidget
                                      title="Select type "
                                      options={['Full Estate','Stand Alone Property']} 
                                      onSelectionChange={(option)=>handleSelectionChange('type',option)}
                                    />
                                  </div>
                            </div>
                            <div className='col s12 m12 l12'>
                                <InputFieldTitleText>
                                    Address
                                </InputFieldTitleText>
                                <AppInputField
                                    type="text" 
                                    placholder="alijames@gmail.com"
                                    name='address'
                                    onChange={handleInputChange}
                                    ref={nameRef}

                                required/> 
                            </div>
                            <div className='col s12 '>
                                  <InputFieldTitleText>
                                  Country
                                  </InputFieldTitleText>
                                  <div className='col s12'>
                                    <DropdownWidget
                                      title="Select type "
                                      options={['Nigeria']} 
                                      onSelectionChange={(option)=>handleSelectionChange('country',option)}
                                    />
                                  </div>
                            </div>
                            <div className='col s12 '>
                                  <InputFieldTitleText>
                                  State
                                  </InputFieldTitleText>
                                  <div className='col s12'>
                                    <DropdownWidget
                                      title="Select type "
                                      // options={['Lagos']} 
                                      options={nigerianStates} 
                                      onSelectionChange={(option)=>handleSelectionChange('state',option)}
                                    />
                                  </div>
                            </div>
                            {showlga && 
                            <div className='col s12 '>
                                  <InputFieldTitleText>
                                  City
                                  </InputFieldTitleText>
                                  <div className='col s12'>
                                    <DropdownWidget
                                      title="Select type "
                                      // options={['kosofe']} 
                                      options={localGovernmentAreas[dataObject.state]}
                                      onSelectionChange={(option)=>handleSelectionChange('city',option)}
                                    />
                                  </div>
                            </div>
                            } 
                            
                            
                            {/* <div className='col s12 m12 l12'>
                                <InputFieldTitleText>
                                    As bulit drawing 
                                </InputFieldTitleText>
                                <AppInputField
                                    type="text" 
                                    placholder="alijames@gmail.com"
                                    name='asBuiltDrawing'
                                    onChange={handleInputChange}

                                required/> 
                            </div> */}
                            
                            
                            
                            <div className='row'>
                                
                                <div className='col s12 right' style={{
                                    display:"flex",
                                    flexWrap:"wrap",
                                    justifyContent:"end"
                                }}>
                                    
                                    <div className='' style={{
                                        width:"100px",
                                        padding:"16px "
                                    }}>
                                        <AppInputFieldBtnCancel 
                                    >
                                            Cancel
                                        </AppInputFieldBtnCancel >
                                    </div>
                                    <div className='' style={{
                                        width:"120px",
                                        padding:"16px "
                                    }}>
                                        <AppInputFieldBtn className='' disabled={loading}>
                                            Add
                                        </AppInputFieldBtn>
                                    </div>
                                </div>
                            </div>
                            <br/>
                        </div>
                        
                    </div>
                    

                </AddNewEstateContainer>
                </form>
            </div>
            <div className='col s12 m12 l3'></div>
        </div>
           
       
    </div>
  )
}

export default AddAssetsPageWidget